import { getTheme } from "@client/styles/themes";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Toolbox } from "../components/PageSkeleton/Toolbox";

export const Template = (props: templates.UtilityPageTemplate) => (
    <PageSkeleton
        {...props.page}
        breadcrumbs_theme={getTheme(props.page.body.value[0]?.value)}
    >
        <Toolbox value={props.page.body.value} />
    </PageSkeleton>
);
